import { useEffect, useState } from "react";
import { SURAH_NAMES } from "../../shared/surahNames";
import { baseUrl } from "../../shared/baseUrl";

function NarrationAudio({
  narration,
  reciter,
  goBack,
  queue,
  setQueue,
  setCurrentAudio,
  setPlaying,
  liked,
  setLiked,
}) {
  const [narrationData, setnarrationData] = useState(null);
  const [audioList, setAudioList] = useState([]);

  useEffect(() => {
    fetch(baseUrl + `api/v1/reciter/${reciter.slug}/riwaya/${narration.slug}`)
      .then((res) => res.json())
      .then((data) => {
        setnarrationData(data);
        setAudioList(Array.isArray(data.audio) ? data.audio : []);
      })
      .catch(() => {
        setnarrationData(null);
        setAudioList([]);
      });
  }, [narration.slug]);

  const normalizeAudio = (audio, narration) => ({
    id: audio.suid,
    title: SURAH_NAMES[audio.name],
    reciter: narration.reciter,
    riwaya: narration.riwaya || "",
    cover: `${baseUrl}storage/${narration.image}`,
    src: `${audio.path}`,
  });

  const playAudio = (audio) => {
    const normalized = normalizeAudio(audio, narrationData);

    // Copy queue and find index
    let newQueue = [...queue];
    let index = newQueue.findIndex((s) => s.id === normalized.id);

    if (index === -1) {
      newQueue.push(normalized);
      index = newQueue.length - 1;
    }

    setQueue(newQueue);
    setCurrentAudio(index); // Correct index in updated queue
    setPlaying(true);
  };

  const toggleLike = (audio) => {
    const normalized = normalizeAudio(audio, narrationData);

    let newLiked;
    if (liked.includes(normalized.id)) {
      newLiked = liked.filter((id) => id !== normalized.id);
    } else {
      newLiked = [...liked, normalized.id];

      // Add to queue if not present
      if (!queue.find((q) => q.id === normalized.id)) {
        setQueue([...queue, normalized]);
      }
    }

    setLiked(newLiked);
    localStorage.setItem("likedAudioList", JSON.stringify(newLiked));
  };

  const playnarration = () => {
    const normalizedAudioList = audioList.map((s) =>
      normalizeAudio(s, narrationData),
    );

    // Merge new audio list into queue without duplicates
    const newQueue = [...queue];
    normalizedAudioList.forEach((s) => {
      if (!newQueue.find((q) => q.id === s.id)) newQueue.push(s);
    });

    setQueue(newQueue);

    // Start with first narration audio index in the updated queue
    const firstIndex = newQueue.findIndex(
      (q) => q.id === normalizedAudioList[0].id,
    );
    setCurrentAudio(firstIndex);
    setPlaying(true);
  };

  if (!narrationData) {
    return (
      <div className="narration-audio-list">
        <button onClick={goBack}>← Back</button>
        <p>Loading narration...</p>
      </div>
    );
  }

  return (
    <div className="narration-audio-list">
      <nav className="breadcrumb">
        <span className="crumb clickable" onClick={() => goBack("home")}>
          Home
        </span>

        <span className="separator">›</span>

        <span className="crumb clickable" onClick={() => goBack("reciter")}>
          {narrationData.reciter}
        </span>

        <span className="separator">›</span>

        <span className="crumb current">{narrationData.riwaya}</span>
      </nav>

      <div className="narration-hero">
        <img
          className="narration-hero-image"
          src={`${baseUrl}/storage/${narrationData.image}`}
          alt={narrationData.reciter}
        />

        <div className="narration-hero-info">
          <h1 className="narration-title">{narrationData.riwaya}</h1>

          {reciter && (
            <div className="narration-meta">
              <span className="reciter-name">{narrationData.reciter}</span>
            </div>
          )}

          <button className="play-all-btn" onClick={playnarration}>
            ▶ Play All
          </button>
        </div>
      </div>

      <table className="list-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Play / ❤️</th>
          </tr>
        </thead>
        <tbody>
          {audioList.map((audio, index) => (
            <tr key={audio.id}>
              <td>{index + 1}</td>
              <td>{SURAH_NAMES[audio.name]}</td>
              <td>
                <button onClick={() => playAudio(audio)}>▶</button>

                <span className="liked">
                  <button onClick={() => toggleLike(audio)}>
                    {liked.includes(audio.suid) ? "❤️" : "🤍"}
                  </button>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default NarrationAudio;
